import React, { useEffect, useRef, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
//import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications
import NotificationAlert from "react-notification-alert";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import queryString from 'query-string';
import routes from "routes.js";
import useGlobal from "store";
import FinishOnboarding from "components/Onboarding/FinishOnboarding";

const Admin = (props) => {

  const [state, actions] = useGlobal(
    state => state,
    actions => actions
  );

  const notificationAlert = useRef(null);
  const mainPanel = useRef(null);

  const [redirectRoute, setRedirectRoute] = useState(false);
  const [pageState] = useState({
    sidebarMini: true,
    backgroundColor: "blue",
  });


  useEffect(() => {    
    if (navigator.platform.indexOf("Win") > -1) {
      //document.documentElement.className += " perfect-scrollbar-on";
      //document.documentElement.classList.remove("perfect-scrollbar-off");
      //ps = new PerfectScrollbar(mainPanel.current);
    }
  }, []);

  useEffect(() => {
    const parsedParams = queryString.parse(window.location.search);
    if(!state.auth) {
      let storedAuth = false;
      if("v" in parsedParams && "x" in parsedParams) {
        //https://app.streempay.com/admin/dashboard?v=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MzU4NjAzMzAsImRhdGEiOnsiZW1haWwiOiJhbmRyZXcrdXNlckBzdHJlZW1wYXkuY29tIiwidXNlcl9pZCI6MzcsImV4cGlyZXMiOjE2MzU4NjAzMzB9LCJpYXQiOjE2MjgwODQzMzB9.uj69yxnD0nX4GVf4JDJMvS18aBIxTCLs0KclHtjfSTU&x=1635860330&e=andrew+user@streempay.com&u=37
        storedAuth = actions.authActions.queryParamAuthToken(parsedParams.v, parsedParams.x, parsedParams.e, parsedParams.u);
      } else if("v" in parsedParams) {
        actions.authActions.getAuthToken({
            access_code: parsedParams.v
        });
      } else {
        storedAuth = actions.authActions.loadAuth();
        
        if(!storedAuth)  {
          setRedirectRoute('/auth/login');
        }
      }
    }
  }, [state.auth, actions.authActions]);

  const minimizeSidebar = () => {
    var message = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
      message += "deactivated...";
    } else {
      this.setState({ sidebarMini: true });
      message += "activated...";
    }
    document.body.classList.toggle("sidebar-mini");
    var options = {};
    options = {
      place: "tr",
      message: message,
      type: "info",
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  useEffect(() => {
    if(!state.notification) {
        return;
    }
    notificationAlert.current.notificationAlert(state.notification);
  }, [state.notification]);

  const notificationStyle = {
    zIndex: 9999999
  }



    return (redirectRoute ?  <Redirect to={redirectRoute} /> 
      : <div className="wrapper">
        { state.user && (!state.user.has_password || !state.user.first_name || !state.user.last_name || !state.user.active_payment_method_id)
          ? <FinishOnboarding></FinishOnboarding> : <></> }
        <NotificationAlert style={notificationStyle} ref={notificationAlert} />
        <Sidebar
          {...props}
          routes={routes}
          minimizeSidebar={minimizeSidebar}
          backgroundColor={pageState.backgroundColor}
        />
        <div className="main-panel" ref={mainPanel}>
          
          <AdminNavbar
            {...props}
            brandText={getActiveRoute(routes)}
          />
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          {
            // we don't want the Footer to be rendered on full screen maps page
            window.location.href.indexOf("full-screen-maps") !== -1 ? null : (
              <Footer fluid />
            )
          }
        </div>
 
      </div>
    );
}

export default Admin;
